import styled, { css } from 'styled-components'

import SanityLink from '../../SanityLink'

export const FooterLinksList = styled.ul`
  list-style: none;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 0.9375rem;
  margin-bottom: 1rem;
`

export const FooterLinksListEntry = styled.li`
  line-height: 1.5;
  margin: 0.5rem 0;
  text-transform: uppercase;
`

export const HeadingListEntry = styled(FooterLinksListEntry)`
  color: ${({ theme }) => theme.colors.coolGray.cool500};
  font-weight: 600;
  margin-bottom: 25px;
`

export const SubheadingListEntry = styled(FooterLinksListEntry)`
  color: ${({ theme }) => theme.colors.coolGray.cool500};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-weight: 100;
  padding-top: 1rem;
  text-transform: none;
`

const linkStyles = css`
  color: ${({ theme }) => theme.colors.grayscale.white};
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`

export const LinkEntry = styled(SanityLink)`
  ${linkStyles};
`
